export default "__VITE_ASSET__G1j$das5__"